import { omit } from 'lodash';

/**
 * Creates a map of the bottlebooksFields by bottlebooks key if mapped
 * @param {Object} props
 * @param props.bottlebooksFields
 * @param [props.latestBottlebooksFields]
 * @param props.sourceFields
 * @param {{label: string, key: string, required: boolean}[]} props.bottlebooksFieldsSource
 */
function getBottlebooksFieldsMap({
  bottlebooksFields,
  latestBottlebooksFields,
  sourceFields,
  bottlebooksFieldsSource,
}) {
  if (!bottlebooksFields) {
    //use the configuration of the last completed import
    if (latestBottlebooksFields) {
      bottlebooksFields = latestBottlebooksFields;
    } else {
      bottlebooksFields = [];
    }
  }

  bottlebooksFields = bottlebooksFields.map((bbField) => {
    const bottlebooksFieldName = bbField.bottlebooksFieldName;
    const parts = bbField.bottlebooksFieldName.split('.');
    if (parts.length >= 5) {
      return {
        ...bbField,
        bottlebooksFieldName: bottlebooksFieldName.replace(/\.\d+./g, '.0.'), //we don't add multiple options for multiple fields, so here we have to change question.1.value to .0.
      };
    } else {
      return { ...bbField };
    }
  });

  return sourceFields
    .map(({ name }) => name)
    ?.reduce((acc, name) => {
      const fieldMapping = bottlebooksFields?.find(
        (f) => f.importFieldName === name
      );
      if (fieldMapping) {
        //matched by db mapping
        const cleaned = omit(fieldMapping, '__typename');
        acc[fieldMapping.importFieldName] = cleaned;
      } else {
        //matched by exact name
        const nameMapped = bottlebooksFieldsSource?.find(
          ({ label, key }) => name === label || name === key
        );
        if (nameMapped) {
          acc[name] = {
            importFieldName: name,
            bottlebooksFieldName: nameMapped.key,
          };
        }
      }
      return acc;
    }, {});
}
export default getBottlebooksFieldsMap;
